import styled from 'foundations-theming/utils';
import { tableButtonStyles } from './tableButtonStyles';
export const ButtonHoverContainer = styled.div.withConfig({
  displayName: "ButtonHoverContainer"
})(["", ""], tableButtonStyles);